import { render, staticRenderFns } from "./ChatChannels.vue?vue&type=template&id=7861fb5a&scoped=true"
import script from "./ChatChannels.vue?vue&type=script&lang=js"
export * from "./ChatChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861fb5a",
  null
  
)

export default component.exports